

export const state = () => ({
  action: null,
  params: null
});

export const getters = {};

export const mutations = {
  SET_PARAMS(state, response) {
    state.action = response.action;
    state.params = response.params;
  },
  UNSET_PARAMS(state) {
    state.action = null;
    state.params = null;
  },
};

export const actions = {
  async setParams ({ commit }, params) {
    commit('SET_PARAMS', params);
    if(params.nextRequest){
      return this.dispatch(params.nextRequest.action,params.nextRequest.params);
    }
  },
  async unsetParams ({ commit }) {
    commit('UNSET_PARAMS');
  },
};
